module.exports = {
	Starling: require("./Starling").default,
	StatsDisplay: require("./StatsDisplay").default,
}


//////////////////
// WEBPACK FOOTER
// ./lib/starling/core/index.js
// module id = 291
// module chunks = 0